module.exports = __webpack_public_path__ + "media/media/service/support-7f8afef7745777a6405784fbff35a2f5.png";